// @ts-check
import { TOPIC } from 'Util/Message/TopicName';
import postMessageHelper from 'Util/Message/postMessageHelper';
import { useMyCourseData } from 'Domain/MyCourseData';
import { useClassroomContext } from 'Context/ClassroomContext';
import { useLearnCraftVideoPlayer } from 'Context/LearnCraftVideoPlayer';

function useFaqTracking() {
  const { courseCode } = useMyCourseData();
  const { courseId } = useClassroomContext();
  const { getCurrentSubVideoId } = useLearnCraftVideoPlayer();

  const logOpenPanel = () => {
    postMessageHelper(TOPIC.FAQ_OPEN_PANEL, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
    });
  };

  const logClosePanel = (/** @type {LogFaqBaseInfo} */ info) => {
    postMessageHelper(TOPIC.FAQ_CLOSE_PANEL, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  const logItemClicked = (/** @type {LogFaqBaseInfo} */ info) => {
    postMessageHelper(TOPIC.FAQ_ITEM_CLICKED, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  const logVoteItem = (/** @type {LogVoteItemInfo} */ info) => {
    postMessageHelper(TOPIC.FAQ_VOTE_ITEM, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  const logItemBackButtonClicked = (/** @type {LogFaqBaseInfo} */ info) => {
    postMessageHelper(TOPIC.FAQ_ITEM_BACK_BUTTON_CLICKED, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  const logOpenClear = (/** @type {LogFaqBaseInfo=} */ info) => {
    postMessageHelper(TOPIC.FAQ_OPEN_CLEAR, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  const logSubmittedClearTicket = (/** @type {LogSubmittedClearTicketInfo} */ info) => {
    postMessageHelper(TOPIC.FAQ_SUBMITTED_CLEAR_TICKET, {
      courseCode,
      courseId,
      assetId: getCurrentSubVideoId(),
      ...info,
    });
  };

  return {
    logOpenPanel,
    logClosePanel,
    logItemClicked,
    logVoteItem,
    logItemBackButtonClicked,
    logOpenClear,
    logSubmittedClearTicket,
  };
}

export { useFaqTracking };

/**
 * Type must sync with createMPEventData.js *
 * @typedef {Object} LogFaqBaseInfo
 * @property {string} faqId
 * @property {string} faqTitle
 *
 * @typedef {Object} LogVoteItemInfo
 * @property {string} faqId
 * @property {string} faqTitle
 * @property {?number} rating
 * @property {string=} ratingDetail
 *
 * @typedef {Object} LogSubmittedClearTicketInfo
 * @property {string} faqId
 * @property {string} faqTitle
 * @property {string} ticketId
 */
